export function getLabelsConjugationCondition(person, isFamilyMember, customer) {
    return ((person === undefined && !isFamilyMember) ||
        (customer === null || customer === void 0 ? void 0 : customer.personId) === (person === null || person === void 0 ? void 0 : person.id));
}
// Nome da interpolare nei copy (es. "%{name} ha delle allergie?").
export function getLabelsName(person, profile) {
    var _a;
    return (_a = person === null || person === void 0 ? void 0 : person.name) !== null && _a !== void 0 ? _a : profile.name;
}
